import { render, staticRenderFns } from "./FollowUpDetails.vue?vue&type=template&id=c6f5e548&scoped=true&"
import script from "./FollowUpDetails.vue?vue&type=script&lang=js&"
export * from "./FollowUpDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f5e548",
  null
  
)

export default component.exports